export default {
  BusinessPurchaseApplyDetail: {
    status: '申请单状态',
    operationLog: '操作日志',
    number: '申请数量',
    already: '已下采购',
    purchasedNot: '未下采购',
    title: '申请单基本信息',
    code: '采购申请单号',
    remark: '备注',
    warehouseCode: '要求收货仓库',
    reviewTime: '审核时间',
    arrivalTime: '要求到货时间',
    productInformation: '申请商品信息',
    firstReview: '一审',
    secondReview: '二审',
    thirdReview: '三审',
    reviewRemark1: '一审备注',
    reviewRemark2: '二审备注',
    reviewRemark3: '三审备注',
    orderQty: '订货数量',
    reviewResult: '审核结论：',
    reviewResult1: '审核不通过',
    reviewResult2: '审核通过',
    reviewRemark: '审核备注:',
    wordLimitText: '2500字以内',
    errorMsg1: '审核结论不能为空！',

    table: {
      picture: '商品图片',
      supplierCode: '要求供应商',
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      skuName: 'SKU名称',
      planQty: '申请数量',
      alreadyQty: '已下采购数量',
      associate: '关联单据',
      associateType: '关联单据类型',
      associatedCode: '关联单号',
      associatedStatusMeaning: '单据状态',
    },

    dialogText1: '采购申请单',
    dialogText2: '日志',
  }
};
